import script from "./SkillsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillsPage.vue?vue&type=script&lang=ts&setup=true"

import "./SkillsPage.vue?vue&type=style&index=0&id=48c32e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c32e3c"]])

export default __exports__